import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { FooterConfig, NavbarScreen, SupportScreen } from "../../components";
import { getStoragePersist } from "../../constants";

import FormLogin from "./components/FormLogin";

const LoginScreen = () => {
  const history = useHistory();
  useEffect(() => {
    checkUser();
  }, []);
  const checkUser = async () => {
    const token = (await localStorage.getItem("USER_TOKEN")) || "";
    const userID = (await localStorage.getItem("USER_ID")) || "";
    if (token === null && userID !== null) {
      history.replace("/manage-register");
    }
  };

  return (
    <>
      <NavbarScreen />
      <div className="LoginScreen container">
        <div className="row">
          <div className="content__left col-md-9 col-sm-12 p-0">
            <h1 className="content__title--one">
              Tra cứu lịch đăng kí tiêm chủng
            </h1>

            <FormLogin />
          </div>
          <div className="content__right col-md-3 col-sm-12 pr-0">
            <SupportScreen />
          </div>
        </div>
      </div>

      <FooterConfig />
    </>
  );
};

export default LoginScreen;
